<script>
import Icon from 'dashboard/components-next/icon/Icon.vue';
import WithLabel from './WithLabel.vue';

export default {
  components: {
    Icon,
    WithLabel,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      required: true,
    },
    modelValue: {
      type: String,
      default: '',
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue'],
  methods: {
    onInput(e) {
      this.$emit('update:modelValue', e.target.value);
    },
  },
};
</script>

<template>
  <WithLabel
    :label="label"
    :icon="icon"
    :name="name"
    :has-error="hasError"
    :error-message="errorMessage"
  >
    <div class="relative w-full">
      <select
        :id="id"
        :selected="modelValue"
        :name="name"
        :class="{
          'text-n-slate-9': !modelValue,
          'text-n-slate-12': modelValue,
          'pl-9': icon,
          'error outline-n-ruby-8 dark:outline-n-ruby-8 hover:outline-n-ruby-9':
            hasError,
          'outline-n-weak hover:outline-n-slate-6 focus:outline-n-brand':
            !hasError,
        }"
        class="reset-base block w-full h-8 mb-0 !appearance-none [-webkit-appearance:none] [-moz-appearance:none] [&::-ms-expand]:hidden rounded-lg border-0 bg-n-alpha-black2 py-1.5 pl-3.5 pr-10 text-sm leading-5 shadow-sm outline outline-1 outline-offset-[-1px] transition-colors"
        @input="onInput"
      >
        <option value="" disabled selected class="hidden">
          {{ placeholder }}
        </option>
        <slot>
          <option v-for="opt in options" :key="opt.value" :value="opt.value">
            {{ opt.label }}
          </option>
        </slot>
      </select>
      <span
        class="pointer-events-none absolute inset-y-0 right-0 z-[1] flex w-10 items-center justify-center text-n-slate-10"
        aria-hidden="true"
      >
        <Icon icon="i-lucide-chevron-down" class="size-4 shrink-0" />
      </span>
    </div>
  </WithLabel>
</template>
